module.exports = __webpack_public_path__ + "static/media/sema.24a21767.png";